import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-primary-dark text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_a8ffb7c6-de37-44aa-9280-081d48fa4acd/artifacts/u74pggg7_CHAMP%20Logo.png" 
                alt="Population, Community, Public Health Services Center Logo"
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-300 text-sm mb-4">
              Providing comprehensive population-health, community-health, and public-health solutions designed for tribal communities, rural regions, and healthcare organizations.
            </p>
            <p className="text-gray-400 text-xs">Innovative Native, LLC</p>
          </div>

          <div>
            <h4 className="font-semibold mb-4 font-heading">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services" className="text-gray-300 hover:text-primary transition-colors" data-testid="footer-link-services">Services</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-primary transition-colors" data-testid="footer-link-about">About Us</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-primary transition-colors" data-testid="footer-link-blog">Blog</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-primary transition-colors" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 font-heading">Contact Info</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2 text-gray-300">
                <Mail size={16} className="mt-1 flex-shrink-0 text-primary" />
                <span className="break-all">pcphservices@gmail.com</span>
              </li>
              <li className="flex items-start gap-2 text-gray-300">
                <Phone size={16} className="mt-1 flex-shrink-0 text-primary" />
                <span>(505) 879-6673</span>
              </li>
              <li className="flex items-start gap-2 text-gray-300">
                <MapPin size={16} className="mt-1 flex-shrink-0 text-primary" />
                <span>Serving Tribal Communities & Rural Regions Nationwide</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400 text-center sm:text-left">&copy; {new Date().getFullYear()} Population, Community, Public Health Services Center a special project under Innovative Native, LLC. All rights reserved.</p>
            <Link to="/admin/login">
              <button className="text-xs text-gray-500 hover:text-primary transition-colors" data-testid="footer-admin-link">
                Admin Login
              </button>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
